<template>
  <div class="view-page">
    <title-bar title="Mi Perfil" :eyebrow="profile.fullName || ''" />

    <div class="me-body">

      <!-- Datos personales -->
      <section class="me-section">
        <div class="me-section__head">
          <h2 class="me-section__title">Datos personales</h2>
          <p class="me-section__desc">Tu información de identificación en la plataforma.</p>
        </div>
        <div class="me-section__content">
          <div class="me-field">
            <span class="me-field__label">Nombre completo</span>
            <span class="me-field__value">{{ profile.fullName || '—' }}</span>
          </div>
          <div class="me-divider" />
          <div class="me-field">
            <span class="me-field__label">Rol</span>
            <span class="me-field__value">
              <span class="me-badge">{{ profile.role ? getRoleName(profile.role) : '—' }}</span>
            </span>
          </div>
        </div>
      </section>

      <!-- Contacto -->
      <section class="me-section">
        <div class="me-section__head">
          <h2 class="me-section__title">Información de contacto</h2>
          <p class="me-section__desc">Correo electrónico asociado a tu cuenta.</p>
        </div>
        <div class="me-section__content">
          <div class="me-field">
            <span class="me-field__label">Correo electrónico</span>
            <span class="me-field__value">{{ profile.email || '—' }}</span>
          </div>
        </div>
      </section>

      <!-- Seguridad -->
      <section class="me-section">
        <div class="me-section__head">
          <h2 class="me-section__title">Seguridad</h2>
          <p class="me-section__desc">Mantén tu cuenta protegida con una contraseña segura.</p>
        </div>
        <div class="me-section__content">
          <div class="me-field me-field--action">
            <div>
              <span class="me-field__label">Contraseña</span>
              <span class="me-field__value me-field__value--masked">••••••••••••••••</span>
            </div>
            <button class="me-btn-link" @click="openModalAction">
              Actualizar contraseña
            </button>
          </div>
        </div>
      </section>
      <active-devices />
    </div>
    <reset-password-modal :openModal="openModal" :close="openModalAction" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '../../mixins/formats'
export default {
  components: {
    TitleBar: () => import('@/components/ui/TitleBar.vue'),
    ResetPasswordModal: () => import('@/components/Profile/ResetPassword.vue'),
    ActiveDevices: () => import('@/components/Profile/ActiveDevices.vue')
  },
  mixins: [mixins],
  data () {
    return {
      loading: false,
      openModal: false
    }
  },
  methods: {
    ...mapActions(['changePass']),
    openModalAction () {
      this.openModal = !this.openModal
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: (state) => state.financialCompany
    })
  }
}
</script>

<style lang="scss" scoped>
// ── Body ────────────────────────────────────────────────────
.me-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

// ── Section ─────────────────────────────────────────────────
.me-section {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 1.5rem;
  background: #ffffff;
  border: 1px solid #eef0f3;
  border-radius: 12px;
  padding: 1.75rem 2rem;
}
.me-section__head {
  padding-right: 1rem;
  border-right: 1px solid #eef0f3;
}
.me-section__title {
  font-size: 14px;
  font-weight: 600;
  color: #1a2233;
  margin: 0 0 6px;
}
.me-section__desc {
  font-size: 12px;
  color: #9aa5b4;
  line-height: 1.5;
  margin: 0;
}

// ── Content ─────────────────────────────────────────────────
.me-section__content {
  display: flex;
  flex-direction: column;
}

// ── Field ───────────────────────────────────────────────────
.me-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0;
  min-height: 52px;
}
.me-field--action {
  align-items: center;
}
.me-field__label {
  font-size: 12px;
  font-weight: 500;
  color: #9aa5b4;
  min-width: 140px;
}
.me-field__value {
  font-size: 13px;
  font-weight: 500;
  color: #2d3748;
}
.me-field__value--masked {
  letter-spacing: 2px;
  color: #b0bac7;
  font-size: 11px;
}

.me-divider {
  height: 1px;
  background-color: #eef0f3;
}

// ── Badge ───────────────────────────────────────────────────
.me-badge {
  display: inline-block;
  background: #f0f3ff;
  color: #4c70ff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 20px;
  padding: 3px 12px;
}

// ── Link button ─────────────────────────────────────────────
.me-btn-link {
  font-size: 12px;
  font-weight: 600;
  color: #4c70ff;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
  transition: color 0.15s;
  &:hover {
    color: darken(#4c70ff, 10%);
    text-decoration: underline;
  }
}
</style>
